module.exports = __webpack_public_path__ + "img/w70_fs.4d37a2cd.png";